var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Grid, GridColumn, TextField, Field } from "@atlassiansox/microscopekit";
import { DatePicker } from "@atlaskit/datetime-picker";
export var WargameExerciseForm = function () { return (React.createElement(Grid, null,
    React.createElement(GridColumn, { medium: 6 },
        React.createElement(TextField, { name: "name", label: "Name", placeholder: "E.g. - Sep 2021 - CPU and Network", isRequired: true })),
    React.createElement(GridColumn, { medium: 6 },
        React.createElement(Field, { name: "dueDate", label: "Due Date" }, function (_a) {
            var fieldProps = _a.fieldProps;
            return (React.createElement(DatePicker, __assign({}, fieldProps, { placeholder: "Select date..." })));
        })))); };
